import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";
import { RoundedButton } from "../../../components/styled/styled";

type Props = {
  collapsed: boolean;
  count: number;
  hideDeleteAll: boolean;
  onExpand: () => void;
  onCollapse: () => void;
  onDeleteAll: () => void;
};

export const ToggleFilters = ({
  collapsed,
  count,
  hideDeleteAll,
  onExpand,
  onCollapse,
  onDeleteAll,
}: Props) => {
  const { t } = useTranslation();

  if (!collapsed) {
    return (
      <IconButton
        size="small"
        aria-expanded
        aria-label={t("common:hideFilters")}
        onClick={onCollapse}
      >
        <KeyboardArrowUpIcon fontSize="small" />
      </IconButton>
    );
  }

  return (
    <>
      <RoundedButton
        variant="text"
        onClick={onExpand}
        startIcon={<KeyboardArrowDownIcon />}
        aria-expanded={false}
        aria-label={t("common:showFilters")}
        sx={{
          minWidth: 0,
          textTransform: "none",
          color: "text.primary",
          fontWeight: 400,
        }}
      >
        {t("common:filtersCollapsed", { count })}
      </RoundedButton>
      {!hideDeleteAll && (
        <IconButton
          size="small"
          aria-label={t("common:deleteAllFilters")}
          onClick={onDeleteAll}
          sx={{ ml: "auto" }}
        >
          <DeleteOutlineIcon fontSize="small" />
        </IconButton>
      )}
    </>
  );
};
